import { FC } from 'react'
import type { Product } from '@commerce/types'
import { Text } from '@components/ui'

interface Props {
  product: Product.Product
}

const ProductDescription: FC<Props> = ({ product }) => {
  if (!product?.descriptionHtml) return null

  const splited = product.descriptionHtml.split('<br>')
  const stripped = splited.map((line) => line.split('***')[0])
  const refined = stripped.join('<br>')

  return (
    <div>
      <div className="text-16 leading-6 pt-8 pb-3 max-w-2xl">
        <Text html={refined} className="product-details" />
      </div>
      <style jsx global>
        {`
          .product-details p {
            font-size: 16px;
            color: #474747;
            line-height: 24px;
          }
          .product-details span {
            font-size: 16x;
            color: #474747;
            line-height: 24px;
          }
          .product-details ul {
            font-size: 16px;
            list-style-type: disc;
            list-style-position: inside;
            color: #474747;
            line-height: 24px;
          }
        `}
      </style>
    </div>
  )
}

export default ProductDescription
